export default __webpack_public_path__ + "static/media/rm-chat-icon.b241df1f.svg";